import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMyMealsMenu } from "../../hooks/useMyMealsMenu";
import { MyMealsMenuComponent } from "./MyMealsMenuComponent";
import { MyMealsMenuTrigger } from "./MyMealsMenuTrigger";
import { MyMealsMenuWrapper } from "./MyMealsMenuWrapper";
export const MyMealsMenu = ({ isNavDrawer, displayText, }) => {
    const M = useMyMealsMenu(isNavDrawer);
    return (_jsxs(MyMealsMenuWrapper, Object.assign({ isNavDrawer: isNavDrawer, isSelectedMenuItem: M.isMyMealsPage }, { children: [_jsx(MyMealsMenuTrigger, { M: M, isNavDrawer: isNavDrawer, displayText: displayText }), _jsx(MyMealsMenuComponent, { M: M, isNavDrawer: isNavDrawer })] })));
};
